import Vue from 'vue';

// TODO: remove this code and import directives where it needed
const context = require.context('.', true, /\.js$/);
context.keys().forEach((fileName) => {
  if (fileName === './index.js') return;
  const name = fileName.replace(/(\.\/|\.js)/g, '');
  Vue.directive(name, context(fileName).default);
});
